import r from"./enhanceError.js";var n,e;function o(){if(e)return n;e=1;var o=r;return n=function(r,n,e,t,u){var a=new Error(r);return o(a,n,e,t,u)}}export{o as __require};
